export function resetAjaxLoadMore(debug = false) {
    if (debug) console.group('ALM Debugging (reset)');

    if (window.ajaxloadmore && typeof window.ajaxloadmore.reset === 'function') {
        if (debug) console.log('Resetting ajaxloadmore...');
        window.ajaxloadmore.reset();
    }

    if (window.almfilters && typeof window.almfilters.reset === 'function') {
        if (debug) console.log('Resetting almfilters...');
        window.almfilters.reset();
    }

    if (debug) console.groupEnd();
}

export function reinitializeAjaxLoadMore(container, debug = false) {
    if (debug) console.group('ALM Debugging (re-init)');

    let almContainers = Array.from(container.querySelectorAll('.ajax-load-more-wrap'));
    // Fallback: Check if the container itself is the ALM wrapper
    if (container.classList.contains('ajax-load-more-wrap')) {
        almContainers.push(container);
    }
    if (debug) console.log('ALM Containers found:', almContainers);

    if (window.ajaxloadmore) {
        if (typeof window.ajaxloadmore.start === 'function') {
            if (almContainers.length > 0) {
                if (debug) console.log('Restarting ajaxloadmore...');
                almContainers.forEach(el => {
                    window.ajaxloadmore.start(el);
                });
            } else {
                if (debug) console.log('ALM container not found, skipping ajaxloadmore.start()');
            }
        } else {
            if (debug) console.warn('window.ajaxloadmore.start is not a function');
        }
    } else {
        if (debug) console.warn('window.ajaxloadmore is undefined');
    }

    if (window.almfilters) {
        if (typeof window.almfilters.start === 'function') {
            if (almContainers.length > 0) {
                if (debug) console.log('Restarting almfilters...');
                window.almfilters.start();
            } else {
                if (debug) console.log('ALM container not found, skipping almfilters.start()');
            }
        } else {
            if (debug) console.warn('window.almfilters.start is not a function');
        }
    }

    if (debug) console.groupEnd();
}